import React, { useState, useEffect } from "react";

const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

const FunctionProgressBar = ({ label, timeStart, functionSecondsAllocated, isDark = false }) => {
    const [elapsedTime, setElapsedTime] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = Date.now();
            const elapsed = Math.floor((now - new Date(timeStart).getTime()) / 1000);
            setElapsedTime(elapsed);
        }, 1000);

        return () => clearInterval(interval);
    }, [timeStart]);

    const progressPercentage = Math.min((elapsedTime / functionSecondsAllocated) * 100, 100);
    const isOverTime = elapsedTime > functionSecondsAllocated;
    const overagePercentage = isOverTime ? ((elapsedTime - functionSecondsAllocated) / functionSecondsAllocated) * 100 : 0;

    return (
        <div>
            {/* <label className="d-block mb-1">{label}</label> */}
            <div className="progress bg-light position-relative" style={{ height: "12px" }}>
                <div
                    className="progress-bar bg-secondary"
                    role="progressbar"
                    style={{ width: `${progressPercentage}%` }}
                    aria-valuenow={elapsedTime}
                    aria-valuemin="0"
                    aria-valuemax={functionSecondsAllocated}
                ></div>
                {isOverTime && (
                    <div
                        className="progress-bar bg-danger"
                        role="progressbar"
                        style={{ width: `${overagePercentage}%` }}
                    ></div>
                )}
                {/* Tick mark for allocated time */}
                <div
                    style={{
                        position: "absolute",
                        left: `${Math.min(100, (functionSecondsAllocated / elapsedTime) * 100)}%`,
                        top: 0,
                        bottom: 0,
                        width: "2px",
                        backgroundColor: "black",
                    }}
                ></div>
            </div>
            <div className="text-center mt-1 fw-medium" style={{ color: '#666', fontSize: '1.1em' }}>
                {formatTime(functionSecondsAllocated)} / {formatTime(elapsedTime)}
            </div>
        </div>
    );
};

export default FunctionProgressBar;
